import { useState, useEffect } from "react";
import { useAxios } from "hooks";
import store from "services/redux/store";
import { NOTIFICATION_TYPE } from "./constants";
import { AXIOS_METHODS } from "constants/common";
import { useDispatch, useSelector } from "react-redux";
import { processNotifications } from "services/redux/thunk/notification";
import { MAANGE_SWAP_OR_TRANSFER, MANAGE_PROVIDER_SHIFT_ASSIGNMENT, MANAGE_FORECASTER_SHIFT_ASSIGNMENT, MARK_NOTIFICATIONS_READ } from "constants/apiEndpoints";

const useNotificationsDrawer = ({open}) => {
  const dispatch = useDispatch();
  const userState = store.getState()?.user?.user;
  const providerId = userState?.provider_id;

  const [selectedNotification, setSelectedNotification] = useState(null);

  const {
    triggerApi: triggerManageShiftRequestApi,
    loading: manageShiftRequestLoading,
  } = useAxios({
    url: MAANGE_SWAP_OR_TRANSFER,
    method: AXIOS_METHODS.POST,
    onInit: false,
  });

  const {
    triggerApi: triggerProviderShiftAssignmentRequestApi,
    loading: providerShiftAssignmentRequestLoading,
  } = useAxios({
    url: MANAGE_PROVIDER_SHIFT_ASSIGNMENT,
    method: AXIOS_METHODS.POST,
    onInit: false,
  });

  const {
    triggerApi: triggerForecasterShiftAssignmentRequestApi,
    loading: forecasterShiftAssignmentRequestLoading,
  } = useAxios({
    url: MANAGE_FORECASTER_SHIFT_ASSIGNMENT,
    method: AXIOS_METHODS.POST,
    onInit: false,
  });

  const {
    triggerApi: triggerMarkNotificationsReadRequestApi,
    loading: markNotificationsReadRequestLoading,
  } = useAxios({
    url: MARK_NOTIFICATIONS_READ,
    method: AXIOS_METHODS.POST,
    onInit: false,
  });


  const notifications = useSelector(
    (state) => state.notification.notifications
  );

  const timezone = useSelector((state) => state.user.user.timezone);
  const role = useSelector((state) => state.user.user.role);

  useEffect(() => {
    const markReadNotifications = async () => {
      if (open){
        await triggerMarkNotificationsReadRequestApi({data: {request_type: "all"}});
      }
    }
    markReadNotifications()
  }, [open]);

  const handleShiftRequest = (notification, action) => async () => {
    setSelectedNotification(notification);
    let response;
    if(notification.type == NOTIFICATION_TYPE.PROVIDER_SHIFT_ASSIGNMENT){
      response = await triggerProviderShiftAssignmentRequestApi({
        data: { requestId: notification?.id, action },
      });
    } else if(notification.type == NOTIFICATION_TYPE.FORECASTER_ASSIGNMENT_REQUEST) {
      response = await triggerForecasterShiftAssignmentRequestApi({
        data: { requestId: notification?.id, action, providerId },
      });
    } else{
      response = await triggerManageShiftRequestApi({
        data: { requestId: notification?.id, action },
      });
    }
    if (response?.success) {
      dispatch(processNotifications());
    }
  };

  const getIfShiftActionInProgress = (notification) =>
    notification.id === selectedNotification?.id && (manageShiftRequestLoading || providerShiftAssignmentRequestLoading || forecasterShiftAssignmentRequestLoading);


  return {
    role,
    timezone,
    notifications,
    handleShiftRequest,
    manageShiftRequestLoading,
    getIfShiftActionInProgress,
  };
};

export default useNotificationsDrawer;
